import { styled } from 'nativewind'
import { View } from 'react-native'

export const Stack = styled(View, 'flex-col')
export const YStack = styled(View, 'flex-col')
export const XStack = styled(View, 'flex-row')
